export interface GenerateLock {
  tryStart: () => boolean;
  release: () => void;
  isGenerating: () => boolean;
}

export function createGenerateLock(): GenerateLock {
  let generating = false;
  return {
    tryStart: () => {
      if (generating) return false;
      generating = true;
      return true;
    },
    release: () => {
      generating = false;
    },
    isGenerating: () => generating,
  };
}
